import { useCallback } from 'react';
import { ModalFooter } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from 'components/button/Button';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import { useLocation, useNavigate } from 'react-router-dom';

interface ScheduledMessagesSendNowModalFooterProps {
  scheduledMessage: ScheduledMessage;
}

const ScheduledMessagesSendNowModalFooter = ({
  scheduledMessage,
}: ScheduledMessagesSendNowModalFooterProps) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();
  const { closeModal } = useAppModal();
  const modalId = useModalId();
  const navigate = useNavigate();
  const location = useLocation();

  const onReschedule = useCallback(() => {
    closeModal(modalId);
    navigate(`${location.pathname}/${scheduledMessage.uid}/reschedule`);
  }, [modalId, navigate, scheduledMessage, closeModal, location.pathname]);

  return (
    <ModalFooter>
      <ModalFormCancelButton />

      <Button
        $colorScheme="green"
        data-testid="modal-form-reschedule-button"
        disabled={isSubmitting}
        onClick={onReschedule}
      >
        {t('common.reschedule')}
      </Button>

      <ModalFormSubmitButton disabledIfNotDirty={false}>
        {isSubmitting
          ? t('common.saving')
          : t('pageAutomations.scheduledMessages.modalSendNow.sendNow')}
      </ModalFormSubmitButton>
    </ModalFooter>
  );
};

export default ScheduledMessagesSendNowModalFooter;
